import { Building } from '@carbon/icons-react';
import * as React from 'react';
import { useHistory } from 'react-router-dom';
import { NavbarItem } from 'vet-bones/components';

import { NAVBAR_ORG_DASHBOARD_BUTTON } from 'src/ui/constants/testIds';
import { useOrgDomain } from 'src/ui/hooks/navbar/connection';
import * as copy from 'src/ui/templates/copy';
import { buildDashboardRoute } from 'src/ui/utils/buildRoute';

export const useNavbarOrgDashboardSchema = (): NavbarItem[] => {
  const history = useHistory();
  const orgDomain = useOrgDomain();

  return React.useMemo(
    () =>
      orgDomain
        ? [
            {
              icon: Building,
              label: copy.components.navbar.organization.dashboard,
              onClick: () => history.push(buildDashboardRoute(orgDomain)),
              testId: NAVBAR_ORG_DASHBOARD_BUTTON,
            },
          ]
        : [],
    [history, orgDomain]
  );
};
